exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app-content.logged {\n  padding: 20px 20px 20px 220px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden; }\n\n#app-content h2 {\n  text-align: center;\n  font-size: 25px;\n  font-style: bold;\n  margin-top: 50px;\n  margin-bottom: 30px;\n  color: #FFF; }\n\n.disconnection-warning {\n  padding: 20px;\n  z-index: 9999;\n  text-align: center;\n  position: absolute;\n  background-color: #ff6d70;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 10px;\n  color: #FFF; }\n  .disconnection-warning button {\n    margin: 10px auto 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main